export default {
  vehicles: state => state.vehicles,
  vehicle: state => state.vehicle
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/getters.js